<template lang="pug">
  .center.bg
    section.margin-top.custom-width
      el-row(:gutter="16")
        el-col(:xs="24", :sm="16", :md="16")
          h5.text-primary Alguns serviços
          h2
            |Colecionando ótimos
            span.space
            span.text-secondary serviços
        el-col(:xs="24", :sm="8", :md="8")
          el-button.bold.btn-custom(:class="$root.screenW >= 768?'right':''", round, type="danger", data-aos="fade-right", data-aos-delay="600")
              |Ver mais
              span.space
              i.el-icon-right
      el-carousel.margin-top(:interval="4000", type="card", :height="$root.screenW<768?'300px':'500px'")
        el-carousel-item(v-for="(item, i) in list", :key="i")
          .item
            .center
              div
                img(:src="item.url")
</template>

<script>
export default {
  name: 'portfolio',
  data: () => ({
    list: [
      {
        url: require('@/assets/img/servico1.png')
      },
      {
        url: require('@/assets/img/servico2.png')
      },
      {
        url: require('@/assets/img/servico1.png')
      }
    ]
  })
}
</script>

<style lang="sass" scoped>
  @import '../../assets/sass/bootloader'
  .bg
    background-image: url('../../assets/svg/circulo.svg')
    background-size: 40%
    background-repeat: no-repeat
    background-position: -25%
    @media (max-width: 767px)
      background-size: 90%
      background-position: -500% 2%
  h5
    font-size: $f-size*1.1
  h1
    font-size: $f-size*2
  h3, h2
    font-family: 'Kanit', sans-serif
    margin-bottom: 16px
</style>